export default __webpack_public_path__ + "static/media/iToons.892b8966.png";